import axios from "axios";
import { beforeRequestHandler } from "./HandleGlobalInterceptors";
import config from "@/config";
var instanceV1 = axios.create({ baseURL: config.messagingBffUrl });
var APIInstanceMessagingBFF = /** @class */ (function () {
    function APIInstanceMessagingBFF(instance) {
        var _this = this;
        // NOTE: deliberately no response interceptor. The shared `requestErrorHandler`
        // clears the auth cache and redirects to /auth/login on any 401, which would
        // eject the user out of the Hub whenever this separate service is down,
        // misconfigured or not yet deployed. The BFF has no OTP step-up flow, so
        // rejecting locally loses nothing.
        this.registerGlobalRequestInterceptors = function () {
            _this.instance.interceptors.request.use(beforeRequestHandler);
        };
        this.instance = instance;
        this.registerGlobalRequestInterceptors();
    }
    Object.defineProperty(APIInstanceMessagingBFF.prototype, "buffedInstances", {
        get: function () {
            return this.instance;
        },
        enumerable: false,
        configurable: true
    });
    APIInstanceMessagingBFF.prototype.setAuthorizationToken = function (token) {
        try {
            this.instance.defaults.headers["Authorization"] = "Bearer ".concat(token);
        }
        catch (error) {
            console.error("Failed to set authorization token: ".concat(error));
        }
    };
    return APIInstanceMessagingBFF;
}());
export var MPInstanceMessagingBFF = new APIInstanceMessagingBFF(instanceV1);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVxdWVzdEF4aW9zTWVzc2FnaW5nQkZGLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiUmVxdWVzdEF4aW9zTWVzc2FnaW5nQkZGLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBd0IsTUFBTSxPQUFPLENBQUM7QUFDN0MsT0FBTyxFQUFFLG9CQUFvQixFQUFFLE1BQU0sNEJBQTRCLENBQUM7QUFDbEUsT0FBTyxNQUFNLE1BQU0sVUFBVSxDQUFDO0FBRTlCLElBQU0sVUFBVSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUMsRUFBRSxPQUFPLEVBQUUsTUFBTSxDQUFDLGVBQWUsRUFBRSxDQUFDLENBQUM7QUFFckU7SUFHRSxpQ0FBWSxRQUF1QjtRQUFuQyxpQkFHQztRQWNELCtFQUErRTtRQUMvRSw2RUFBNkU7UUFDN0Usd0VBQXdFO1FBQ3hFLHlFQUF5RTtRQUN6RSxtQ0FBbUM7UUFDM0Isc0NBQWlDLEdBQUc7WUFDMUMsS0FBSSxDQUFDLFFBQVEsQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDO1FBQy9ELENBQUMsQ0FBQztRQXZCQSxJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztRQUN6QixJQUFJLENBQUMsaUNBQWlDLEVBQUUsQ0FBQztJQUMzQyxDQUFDO0lBRUQsc0JBQVcsb0RBQWU7YUFBMUI7WUFDRSxPQUFPLElBQUksQ0FBQyxRQUFRLENBQUM7UUFDdkIsQ0FBQzs7O09BQUE7SUFFTSx1REFBcUIsR0FBNUIsVUFBNkIsS0FBYTtRQUN4QyxJQUFJO1lBQ0YsSUFBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLGVBQWUsQ0FBQyxHQUFHLGlCQUFVLEtBQUssQ0FBRSxDQUFDO1NBQ3JFO1FBQUMsT0FBTyxLQUFLLEVBQUU7WUFDZCxPQUFPLENBQUMsS0FBSyxDQUFDLDZDQUFzQyxLQUFLLENBQUUsQ0FBQyxDQUFDO1NBQzlEO0lBQ0gsQ0FBQztJQVVILDhCQUFDO0FBQUQsQ0FBQyxBQTVCRCxJQTRCQztBQUVELE1BQU0sQ0FBQyxJQUFNLHNCQUFzQixHQUFHLElBQUksdUJBQXVCLENBQUMsVUFBVSxDQUFDLENBQUMifQ==